export const ADMIN_ORCHESTRATOR_API_ERROR = 'evolveos:admin-orchestrator-api-error';

export type AdminApiErrorDetail = {
  status: number;
  message: string;
};

/** Dispatch globally so Layout can show Snackbar without prop drilling axios. */
export function dispatchAdminOrchestratorApiError(detail: AdminApiErrorDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ADMIN_ORCHESTRATOR_API_ERROR, { detail }));
}
